import React from 'react'
import FloatBar from './FloatBar'
import SideButton from './SideButton'
import AppFooter from './AppFooter'

/**
 * Authenticated application chrome: top bar + left rail + scrollable content.
 */
const AppShell = ({ children, contentClassName = '' }) => {
  return (
    <div className="nx-app-bg flex min-h-screen w-full flex-col text-paper">
      <FloatBar />
      <div className="flex min-h-0 flex-1">
        <aside className="sticky top-0 z-30 flex h-[calc(100vh-4.5rem)] w-16 shrink-0 items-center justify-center sm:w-[4.5rem]">
          <SideButton />
        </aside>
        <main
          className={`flex min-h-0 flex-1 flex-col overflow-y-auto px-4 py-5 sm:px-6 lg:px-8 ${contentClassName}`}
        >
          <div className="flex-1">{children}</div>
          <AppFooter className="mt-12" />
        </main>
      </div>
    </div>
  )
}

export default AppShell
